module.exports = __webpack_public_path__ + "img/SMP.f99f4be9.svg";